import { Component, forwardRef, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export class Embargo {
	embargoFrom: string;
	embargoTo: string;
	constructor() {
		this.embargoTo = null;
		this.embargoFrom = null;
	}
}

@Component({
	selector: 'bb-embargo',
	templateUrl: './bb-embargo.component.html',
	styleUrls: ['./bb-embargo.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbEmbargoComponent),
		multi: true
	}]

})

export class BbEmbargoComponent implements ControlValueAccessor, OnInit {

	embargo: Embargo;
	today: Date = new Date();
	endDate: Date;
	showEndDate = true;
	currentTime: string;

	embargoFromTime: string;
	embargoToTime: string;

	constructor() {
		this.embargo = new Embargo();
	}

	propagateChange = (_: any) => { };

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	writeValue(embargo: Embargo) {
		this.embargo = embargo;
		if (this.embargo) {
			if (this.embargo.embargoFrom) {
				this.embargoFromTime = dayjs(this.embargo.embargoFrom).format('H:mm');

				if (!this.embargo.embargoTo) {
					this.endDate = dayjs(this.embargo.embargoFrom).add(1, 'days').toDate();
					this.embargoToTime = dayjs(this.embargo.embargoFrom).format('H:mm');
				}
			}
			if (this.embargo.embargoTo) {
				this.embargoToTime = dayjs(this.embargo.embargoTo).format('H:mm');
			}
		}
	}

	registerOnTouched() { }

	ngOnInit() { }

	embargoFromChange(event: any) {
		this.embargo.embargoFrom = event.toISOString();
		this.embargo.embargoFrom = this.updateDateWithTime(this.embargo.embargoFrom, this.embargoFromTime);
		this.showEndDate = false;
		if (this.embargo.embargoFrom >= this.embargo.embargoTo) {
			this.getDayLater();
		}
		this.propagateChange(this.embargo);
		setTimeout(() => {
			this.showEndDate = true;
		});
	}

	embargoTimeFromChange(time: string) {
		this.embargo.embargoFrom = this.updateDateWithTime(this.embargo.embargoFrom, time);
		if (this.embargo.embargoFrom >= this.embargo.embargoTo) {
			this.getDayLater();
		}
		this.propagateChange(this.embargo);

	}

	embargoTimeToChange(time: string) {
		this.embargo.embargoTo = this.updateDateWithTime(this.embargo.embargoTo, time);
		this.propagateChange(this.embargo);

	}

	updateDateWithTime(currentDate: string, time: string): string {
		if (time.length && time.indexOf(':') !== -1) {
			const [hours, minutes] = time.split(':');
			const newDateTime = dayjs(currentDate).hour(parseInt(hours, 10)).minute(parseInt(minutes, 10)).second(0).format();
			return newDateTime;
		}
		return currentDate;
	}

	embargoToChange(event: any) {
		this.embargo.embargoTo = event.toISOString();
		this.embargo.embargoTo = this.updateDateWithTime(this.embargo.embargoTo, this.embargoToTime);
		this.propagateChange(this.embargo);
	}

	getToday(): string {
		const today = dayjs().format();
		this.getCurrentTime();
		this.embargo = new Embargo();
		this.embargo.embargoFrom = today;
		this.embargoFromTime = this.currentTime;
		this.embargo.embargoFrom = this.updateDateWithTime(this.embargo.embargoFrom, this.embargoFromTime);
		this.propagateChange(this.embargo);
		return this.embargo.embargoFrom;
	}

	getDayLater(): string {
		const newDate = dayjs(this.embargo.embargoFrom).add(1, 'days').format();
		this.getCurrentTime();
		this.embargo.embargoTo = newDate;
		this.embargoToTime = this.currentTime;
		this.embargo.embargoTo = this.updateDateWithTime(this.embargo.embargoTo, this.embargoToTime);
		this.propagateChange(this.embargo);
		return this.embargo.embargoTo;
	}

	getCurrentTime() { // current time for initial display
		const today = new Date();
		const h = (today.getHours() < 10 ? '0' : '') + today.getHours();
		this.currentTime = h + ':00';
	}

	removeEmbargoFrom() {
		this.embargo.embargoFrom = null;
		this.propagateChange(this.embargo);
	}

	removeEmbargoTo() {
		this.embargo.embargoTo = null;
		this.propagateChange(this.embargo);
	}
}
